module.exports = __webpack_public_path__ + "media/images/story/icon/plus-dd405325756ecc4b2066f432877d8ef1.svg";